import { Event } from "event-system";
import { ITextInput } from "./ITextInput";
import { Input, InputOptions } from "@pixi/ui";
import { IDestroyOptions, Sprite } from "pixi.js";

export class AndroidTextInput extends Input implements ITextInput {
    public onStartEditing: Event<void>;
    private inputMode: string;
    public override get value(): string {
        return super.value;
    }
    public override set value(value: string) {
        super.value = value;
        if (this.input != null) {
            this.input.value = value;
        }
        const newBG = new Sprite((this._bg as Sprite).texture);
        newBG.width = this.inputField.width + 10;
        newBG.height = this._bg.height;
        this.bg = newBG;
        this.align();
    }

    public constructor(options: InputOptions, inputMode: string) {
        super(options);
        this.inputMode = inputMode;
        this.onStartEditing = new Event();
        this._cursor.tint = "#ffffff";
        this.onInputChanged = this.onInputChanged.bind(this);
        window.addEventListener('input', this.onInputChanged);
    }

    public manualyStartEditing(): void {
        this.activation = true;
        this.handleActivation();
    }

    protected override _startEditing(): void {
        this.onStartEditing.emit();
        super._startEditing();
    }

    protected override createInputField(): void {
        super.createInputField();
        this.input.maxLength = this.options.maxLength;
        this.input.setAttribute("inputmode", this.inputMode);
        this.input.value = this.value;
        this.input.style.zIndex = "-1";
    }

    protected override onKeyUp(_e: KeyboardEvent): void {
        // For removing pixi-ui input logic
        return;
    }

    protected onInputChanged(ev: InputEvent): void {
        const inputData = (ev.target as any).value;
        this.value = this.input.value.length > this.options.maxLength ? this.input.value.slice(0, this.options.maxLength) : inputData;
        this.onChange.emit(this.value);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        window.removeEventListener('input', this.onInputChanged);
        super.destroy(options);
    }
}